import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { withRouter, Link } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { GC_USER_ID, GC_AUTH_TOKEN } from '@/constants'
import 'react-table/react-table.css'
import * as moment from 'moment'
import NoSleep from 'nosleep.js/dist/NoSleep'

import {
  Grid,
  Button,
  Typography,
  Modal,
  Paper,
  LinearProgress,
  Avatar
} from 'material-ui'
import List, {
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemAvatar,
  ListItemSecondaryAction
} from 'material-ui/List'
import TextField from 'material-ui/TextField'
import Select from 'material-ui/Select'
import { InputLabel } from 'material-ui/Input'
import { FormControl } from 'material-ui/Form'
import { ALABASTER } from '@/constants'
import AddIcon from 'material-ui-icons/Add'
import RemoveIcon from 'material-ui-icons/Remove'
import CheckIcon from 'material-ui-icons/Check'
import ReplayIcon from 'material-ui-icons/Replay'
import PauseIcon from 'material-ui-icons/Pause'
import PlayArrowIcon from 'material-ui-icons/PlayArrow'
import EditIcon from 'material-ui-icons/Edit'
import DeleteIcon from 'material-ui-icons/Delete'
import TimelapseIcon from 'material-ui-icons/Timelapse'
import AlarmOnIcon from 'material-ui-icons/AlarmOn'
import DateRangeIcon from 'material-ui-icons/DateRange'
import CommentIcon from 'material-ui-icons/Comment'
import AssignmentIcon from 'material-ui-icons/Assignment'
import BookmarkBorderIcon from 'material-ui-icons/BookmarkBorder'
import SentimentSatisfiedIcon from 'material-ui-icons/SentimentSatisfied'
import IconButton from 'material-ui/IconButton'
import AlchemyReadingCalendar from '@/components/ChartTypes/AlchemyReadingCalendar'
import AlchemyReadingWeeklyView from '@/components/ChartTypes/AlchemyReadingWeeklyView'
import AlchemyReadingWeeklyAvg from '@/components/ChartTypes/AlchemyReadingWeeklyAvg'
import AlchemyReadingCurrentBookBurnDown from '@/components/ChartTypes/AlchemyReadingCurrentBookBurnDown'
import ChromeReaderModeIcon from 'material-ui-icons/ChromeReaderMode'
import RefreshIcon from 'material-ui-icons/Refresh'
import ClearIcon from 'material-ui-icons/Clear'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import VisibilityIcon from 'material-ui-icons/Visibility'
import VisibilityOffIcon from 'material-ui-icons/VisibilityOff'

import { READ_DATASETNAME, READ_DATASETS } from '@/graphql/queries/dataset'
import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'

const styles = theme => ({
  paperGoalBlock: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit * 1.5,
    marginBottom: theme.spacing.unit * 5,
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperCalendarView: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 4,
    padding: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #eeeeee',
    color: 'grey'
  },
  todayPanelGrid: {
    position: 'relative',
    textAlign: 'center',
    padding: 20
  },
  iconTodayTime: {
    height: 24,
    width: 24
  },
  button: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperAddTodayMoreInfo: {
    boxShadow: '0px 0px 10px #eeeeee',
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  divBtnAddNew: {
    position: 'relative',
    height: 70,
    textAlign: 'center'
  },
  iconBtnCheck: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  listItemGetUpTime: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: theme.spacing.unit * 0.8
  },
  iconGetUpTimeView: {
    color: 'rgba(0, 0, 0, .1)',
    width: 30,
    height: 30
  },
  weightText: {
    textAlign: 'center',
    padding: 0
  },
  textGetUpTimeView: {
    fontSize: 18,
    color: 'grey'
  },
  textGetUpDate: {
    fontSize: 12,
    color: 'lightgrey'
  },
  paperWidget: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit,
    height: 40,
    borderRadius: theme.spacing.unit * 2
  },
  divAddModalButton: {
    textAlign: 'right',
    paddingRight: theme.spacing.unit * 2
  },
  iconBtnCheckAdd: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    marginBottom: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit
  },
  paperWidgetComment: {
    textAlign: 'left',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit,
    height: 80,
    borderRadius: theme.spacing.unit * 2
  },
  listItemSessionView: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.016)',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: theme.spacing.unit * 0.8
  },
  divWidgetMood: {
    textAlign: 'left',
    height: 80,
    borderRadius: theme.spacing.unit * 2
  },
  paperWidgetMood: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    borderRadius: theme.spacing.unit * 2
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  toolbar: {
    backgroundColor: ALABASTER,
    color: 'white'
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -15,
    left: 0,
    right: 0,
    margin: '0 auto'
  },
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4
  },
  innerWrapTimer: {
    position: 'relative',
    top: -230
  },
  innerWrapTimerText: {
    position: 'relative',
    top: -250
  },
  innerWrapTimerEmoji: {
    position: 'relative',
    top: -100,
    height: 1
  },
  centerBlock: {
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: 270,
    marginTop: theme.spacing.unit * 1.5
  },
  centerBlockBtns: {
    textAlign: 'center',
    width: '100%'
  },
  icon: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  iconNoShadow: {
    margin: theme.spacing.unit
  },
  addTaskText: {
    marginTop: theme.spacing.unit * 2,
    fontSize: 16,
    color: 'lightgrey'
  },
  iconTiny: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    height: 20,
    width: 20,
    margin: theme.spacing.unit
  },
  iconAllProjects: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    height: 20,
    margin: 0
  },
  iconAllProjectsDisabled: {
    boxShadow: '0px 0px 15px #eeeeee',
    height: 20,
    margin: 0
  },
  iconTinyDark: {
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #aaaaaa',
    height: 20,
    width: 20,
    margin: theme.spacing.unit
  },
  iconDark: {
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #aaaaaa',
    margin: theme.spacing.unit
  },
  iconSetDark: {
    color: 'lightgrey',
    height: 28,
    width: 28,
    margin: 5
  },
  iconEdit: {
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #aaaaaa',
    margin: theme.spacing.unit,
    position: 'relative',
    top: -90
  },
  iconPause: {
    margin: theme.spacing.unit,
    height: 180,
    width: 180
  },
  iconHistoryEdit: {
    height: 24,
    width: 24
  },
  iconBigButtons: {
    fontSize: 170
  },
  iconBtnCurrentBookRefresh: {
    color: 'lightgrey',
    height: 20,
    width: 20
  },
  iconBtnCurrentBook: {
    color: 'lightgrey',
    height: 30,
    width: 30
  },
  textInfo: {
    fontSize: 11,
    color: 'grey',
    opacity: 0.8,
    textAlign: 'left',
    backgroundColor: ALABASTER,
    padding: '3%'
  },
  calendar: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: window.innerWidth
  },
  panel: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    width: '100%'
  },
  modalZero: {
    position: 'absolute',
    width: window.innerWidth * 0.4,
    height: window.innerWidth * 0.2,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    boxShadow: theme.shadows[5],
    padding: window.innerWidth * 0.2,
    margin: window.innerWidth * 0.1,
    textAlign: 'center',
    top: window.innerHeight * 0.5,
    borderRadius: 8
  },
  modalContent: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: 20
  },
  listItemSleepTimeComplete: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: 20
  },
  modalContentWhite: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: 20
  },
  modalContentSmall: {
    height: 80,
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#f8f8f8',
    paddingLeft: window.innerWidth * 0.15
  },
  modalContentSmallTime: {
    height: 80,
    width: '100%',
    textAlign: 'center',
    backgroundColor: '#f8f8f8'
  },
  modalContentDone: {
    height: 50,
    width: '100%',
    textAlign: 'left',
    backgroundColor: ALABASTER
  },
  textField: {
    width: window.innerWidth * 0.4
  },
  textFieldSmall: {
    width: window.innerWidth * 0.23
  },
  textFieldMedium: {
    width: window.innerWidth * 0.33
  },
  textFieldShortLength: {
    width: window.innerWidth * 0.22
  },
  textFieldTimeSmall: {
    color: 'grey'
  },
  textFieldTimeTiny: {
    color: 'silver'
  },
  iconSleepScore: {
    color: 'rgba(0, 0, 0, .04)',
    width: 55,
    height: 55
  },
  editIcons: {
    color: 'rgba(0, 0, 0, .1)',
    width: 55,
    height: 55
  },
  editIconsMedium: {
    color: 'rgba(0, 0, 0, .1)',
    width: 35,
    height: 35
  },
  iconSleepAtTimeDate: {
    color: 'rgba(0, 0, 0, .1)',
    width: 20,
    height: 20
  },
  editIconsLight: {
    color: 'rgba(255, 255, 255, .1)',
    width: 55,
    height: 55
  },
  editIconsSmall: {
    color: 'rgba(0, 0, 0, .1)',
    width: 20,
    height: 20
  },
  paperRoot: {
    margin: theme.spacing.unit * 4,
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperRootCurrentBook: {
    margin: theme.spacing.unit * 4,
    boxShadow: '0px 0px 10px #eeeeee',
    height: 180
  },
  paperRootCurrentBookWithoutLength: {
    margin: theme.spacing.unit * 4,
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperRootCurrentBookDark: {
    margin: theme.spacing.unit * 4,
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #888888',
    height: 180
  },
  gridLeft: {
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'rgba(222,184,135, .1)',
    height: 120,
    width: 93,
    position: 'relative',
    top: 30,
    left: 30
  },
  gridLeftDark: {
    boxShadow: '0px 0px 2px #999999',
    backgroundColor: 'rgba(222,184,135, .2)',
    height: 120,
    width: 93,
    position: 'relative',
    top: 30,
    left: 30
  },
  gridLeftCommon: {
    alignItems: 'center'
  },
  gridRight: {
    position: 'relative',
    textAlign: 'left',
    height: 120,
    width: 140,
    top: 25,
    left: 46,
    margin: 20
  },
  gridRightButtons: {
    position: 'relative',
    textAlign: 'left',
    height: 120,
    width: 150,
    top: 5,
    left: 46,
    margin: 20
  },
  bookBlock: {
    position: 'relative',
    textAlign: 'center',
    width: 93
  },
  iconBook: {
    color: 'rgba(0, 0, 0, .1)',
    width: 60,
    height: 60
  },
  linearColorPrimary: {
    backgroundColor: 'rgba(0, 0, 0, .1)'
  },
  linearBarColorPrimary: {
    backgroundColor: 'rgba(80, 227, 194, .4)'
  },
  linearBarColorPrimaryComplete: {
    backgroundColor: 'lightgreen'
  },
  linearBarColorPrimaryGoal: {
    backgroundColor: 'rgba(168, 169, 255,0.5)'
  },
  textFieldInput: {
    position: 'relative',
    width: 45,
    height: 20,
    top: -38,
    left: 95
  },
  textFieldInputNew: {
    position: 'relative',
    width: 45,
    height: 20,
    top: -128,
    left: 165
  },
  gridPageProgress: {
    left: -46
  },
  modalContentInputComment: {
    width: '100%',
    paddingLeft: window.innerWidth * 0.1,
    backgroundColor: 'rgba(0, 0, 0, 0.016)',
    top: -120
  },
  modalAddTodayDark: {
    display: 'inline-block',
    backgroundColor: 'rgba(180, 180, 180, 1)',
    overflow: 'scroll'
  },
  modalAddToday: {
    display: 'inline-block',
    overflow: 'scroll'
  },
  paperAddToday: {
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  divAddTpday: {
    position: 'relative',
    alignItems: 'center',
    width: '100%'
  },
  divClearButton: {
    textAlign: 'right',
    height: 26
  },
  iconClearDark: {
    color: 'rgba(255, 255, 255, .8)',
    fontSize: 26
  },
  iconClear: {
    color: 'rgba(0, 0, 0, .2)',
    fontSize: 26
  },
  textFieldColor: {
    color: 'lightgrey'
  },
  divTodayPanelTitle: {
    textAlign: 'left',
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 4.5
  },
  textFieldDarkMode: {
    color: 'silver'
  }
})

var isSessionPlan = false

@withApollo
@inject('resultUserProjects')
@inject('resultUserProjectsPref')
@inject('resultMyProjectsPref')
@observer
@graphql(READ_DATASETS)
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETNAME, {
  name: 'readProjectsDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultProjects',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readUserProjectsPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultUserProjectsPreference',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readMyProjectsPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultPreferenceMyProjects',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@withRouter
@withStyles(styles)
export default class AlchemyProjects extends Component {
  constructor(props) {
    super(props)
    this.state = {
      OpenAdd: false,
      OpenAddIssue: false,
      OpenView: false,
      openZero: false,
      openDelAll: false,
      openDeleteSession: false,
      openDeleteIssue: false,
      openTimer: false,

      session: 30,
      break: 5,
      timer: 30 * 60,
      isSessionNow: true,
      isPaused: false,
      eAngle: 0,
      isUpdated: false,
      token: 'session',
      isCompleted: false,
      initialStart: true,
      initialStartTimer: true,
      timeStart: '',
      isExtend: false,
      currentSession: [],
      minsRead: 0,
      hasHistory: true,
      time: 0,
      isCommented: false,
      comment: '',
      issueAdd: false,
      sleep: 'Will Sleep',
      isStreakProject: true
    }
    this.handleSessionEdit = this.handleSessionEdit.bind(this)
    this.handleSessionDelete = this.handleSessionDelete.bind(this)
    this.handleSessionDeleteAll = this.handleSessionDeleteAll.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleChangeIssue = this.handleChangeIssue.bind(this)
    this.noSleep = new NoSleep()
  }

  handleStreakSwitch = () => {
    if (this.state.isStreakProject) {
      this.setState({ isStreakProject: false })
    } else {
      this.setState({ isStreakProject: true })
    }
  }

  handleOpenTimer = id => {
    this.props.resultMyProjectsPref.updateCurrentIssue(id)
    this.setState({ openTimer: true })
  }

  handleOpenAddInIssue = id => {
    this.props.resultMyProjectsPref.updateCurrentIssue(id)
    this.handleOpenAdd(moment().format('l'))
  }

  handleOpenAddPlanInIssue = id => {
    isSessionPlan = true
    this.props.resultMyProjectsPref.updateCurrentIssue(id)
    this.handleOpenAdd(moment().format('l'))
  }

  handleCloseTimer = () => {
    this.setState({
      isSessionNow: true,
      initialStartTimer: true
    })
    this.updateState(this.state.session)
    this.setState({
      openTimer: false
    })
  }

  handleOpenAddIssue = () => {
    this.setState({ issueAdd: true })
    const num =
      this.props.resultMyProjectsPref.sessionData.issues.length === 0
        ? 1
        : this.props.resultMyProjectsPref.sessionData.issues[0].id + 1
    const issueNew = {
      id: num,
      issueName: '',
      issueDescription: '',
      minsEstimate: '',
      minsSpend: 0,
      isCurrent: '0',
      isCompleted: '0',
      datePlanned: moment().format('l')
    }
    this.props.resultMyProjectsPref.updateIssueData(issueNew)
    this.props.resultMyProjectsPref.sessionData.issues.splice(0, 0, issueNew)
    this.props.resultMyProjectsPref.updateDataBySession()
    this.handleIssueEdit(
      this.props.resultMyProjectsPref.sessionData.issues[0].id
    )
  }

  handleOpenAdd = date => {
    //('add new session')
    var timeNow = moment().format('HH:mm')
    var strS = date + ' ' + timeNow
    var strE = date + ' ' + timeNow

    const num =
      this.props.resultUserProjects.data.length === 0
        ? 1
        : this.props.resultUserProjects.data[0].id + 1
    const projectSession = {
      id: num,
      timeStart: moment(new Date(strS)).format(),
      timeComplete: moment(new Date(strE)).format(),
      date: date,
      durationMin: '',
      projectId: this.props.resultMyProjectsPref.sessionData.id,
      projectName: this.props.resultMyProjectsPref.sessionData.projectName,
      issueId: this.props.resultMyProjectsPref.currentIssue.id,
      issueName: this.props.resultMyProjectsPref.currentIssue.issueName,
      mood: 0,
      comment: '',
      projectTag: this.props.resultMyProjectsPref.sessionData.tags,
      isPlan: isSessionPlan ? '1' : '0'
    }
    var allData = this.props.resultUserProjects.data
    allData.splice(0, 0, projectSession)
    this.props.resultUserProjects.updateData(allData)
    this.props.resultUserProjects.updateSessionData(projectSession)
    this.handleSessionEdit(this.props.resultUserProjects.data[0].id)
  }

  handleOpenView = date => {
    this.props.resultUserProjects.updatesessionsDataByDate(date)

    this.setState({ OpenView: true })
  }

  handleOpenViewByIssue = (issueId, projectId, issueName) => {
    this.props.resultUserProjects.updatesessionsDataById(
      issueId,
      projectId,
      issueName
    )

    this.setState({ OpenView: true })
  }

  handleCloseView = () => {
    this.setState({
      OpenView: false
    })
  }

  componentWillMount() {
    window.resizeTo(window.screen.availWidth, window.screen.availHeight)
  }

  saveComment = () => {
    this.props.resultUserProjects.sessionData.comment = this.state.comment
    var index = this.props.resultUserProjects.data
      .map(x => {
        return x.id
      })
      .indexOf(this.props.resultUserProjects.sessionData.id)
    this.props.resultUserProjects.data[
      index
    ] = this.props.resultUserProjects.sessionData
    this.updateDataPoints(JSON.stringify(this.props.resultUserProjects.data))
    this.setState({ isCommented: false })
  }

  handleChangeIssue = name => event => {
    if (name === 'minsEstimate') {
      var hours = parseFloat(event.target.value)
      this.props.resultMyProjectsPref.issueData[name] = parseInt(hours * 60, 10)
    } else {
      this.props.resultMyProjectsPref.issueData[name] = event.target.value
    }
    this.props.resultMyProjectsPref.updateSessionByIssue()
    this.props.resultMyProjectsPref.updateDataBySession()
    this.updateDataPointsMyProjectsPref(
      JSON.stringify(this.props.resultMyProjectsPref.data)
    )
  }

  handleChange = name => event => {
    if (name !== 'comment') {
      this.setState({
        [name]: event.target.value
      })
    }
    if (name === 'timeComplete' || name === 'timeStart') {
      var inputTime = moment(event.target.value, 'HH:mm').format('HH:mm')
      var str = this.props.resultUserProjects.sessionData.date + ' ' + inputTime
      if (!moment(new Date(str)).isValid()) {
        //('invalid date input')
        return
      }
      this.props.resultUserProjects.sessionData[name] = moment(
        new Date(str)
      ).format()
      var sTime = moment(
        new Date(this.props.resultUserProjects.sessionData.timeStart)
      )
      var eTime = moment(
        new Date(this.props.resultUserProjects.sessionData.timeComplete)
      )
      if (sTime.isSameOrBefore(eTime)) {
        var mins = moment
          .utc(
            moment(eTime, 'MM/DD/YYYY HH:mm').diff(
              moment(sTime, 'MM/DD/YYYY HH:mm')
            )
          )
          .format('HH:mm')
        var du = moment.duration(mins)
        var dM = du.asMinutes()
        this.props.resultUserProjects.sessionData.durationMin = dM
      }
    } else if (name === 'date') {
      if (!moment(new Date(event.target.value)).isValid()) {
        //('invalid date input')
        return
      }
      this.props.resultUserProjects.sessionData.date = moment(
        event.target.value,
        'YYYY-MM-DD'
      ).format('l')
      var inputTimeEnd = moment(
        new Date(this.props.resultUserProjects.sessionData.timeComplete)
      ).format('HH:mm')
      var inputTimeStart = moment(
        new Date(this.props.resultUserProjects.sessionData.timeStart)
      ).format('HH:mm')
      var strEnd = moment(
        event.target.value + ' ' + inputTimeEnd,
        'YYYY-MM-DDTHH:mm'
      )
      var strStart = moment(
        event.target.value + ' ' + inputTimeStart,
        'YYYY-MM-DDTHH:mm'
      )
      this.props.resultUserProjects.sessionData.timeComplete = moment(
        new Date(strEnd)
      ).format()
      this.props.resultUserProjects.sessionData.timeStart = moment(
        new Date(strStart)
      ).format()
    } else {
      this.props.resultUserProjects.sessionData[name] = event.target.value
    }
    if (
      this.props.resultUserProjects.sessionData.id ===
      this.state.currentSession.id
    ) {
      this.setState({
        currentSession: this.props.resultUserProjects.sessionData
      })
    }
    //update store and database: resultUserProjects
    var index = this.props.resultUserProjects.data
      .map(x => {
        return x.id
      })
      .indexOf(this.props.resultUserProjects.sessionData.id)
    this.props.resultUserProjects.data[
      index
    ] = this.props.resultUserProjects.sessionData
    if (name !== 'comment') {
      this.updateDataPoints(JSON.stringify(this.props.resultUserProjects.data))
    } else {
      this.setState({
        comment: event.target.value,
        isCommented: true
      })
    }
  }

  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    //Code from https://techbrij.com
    var result = {},
      ret = []
    var newCols = []
    for (var i = 0; i < dataArray.length; i++) {
      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {}
      }

      //To get column names
      if (newCols.indexOf(dataArray[i][colIndex]) === -1) {
        newCols.push(dataArray[i][colIndex])
      }
    }

    for (var key in result) {
      var sessions = []
      var mins = 0
      var pages = 0
      for (var j = 0; j < dataArray.length; j++) {
        if (dataArray[j].date === key) {
          sessions.push(dataArray[j])
          result[dataArray[j][rowIndex]][dataArray[j][colIndex]] = sessions
          mins += parseFloat(dataArray[j].durationMin, 10)
          pages += parseFloat(dataArray[j].pages, 10)
          result[dataArray[j][rowIndex]][2] = mins
          result[dataArray[j][rowIndex]][3] = pages
        }
      }
    }

    newCols.sort(function(a, b) {
      return new Date(a) - new Date(b)
    })
    var item = []

    //Add content
    for (key in result) {
      item = []
      item.push(key)
      for (i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || '')
        item.push(result[key][2])
        item.push(result[key][3])
      }
      ret.push(item)
    }
    return ret
  }

  updateStats = (newTime, token, didUpdate) => {
    if (token === 'session') {
      this.setState({
        session: newTime
      })

      this.setState({
        timer: newTime * 60,
        isUpdated: didUpdate
      })
    }
  }

  drawPieSlice = (
    ctx,
    centerX,
    centerY,
    radius,
    startAngle,
    endAngle,
    color
  ) => {
    ctx.fillStyle = color
    ctx.beginPath()
    ctx.moveTo(centerX, centerY)
    ctx.arc(centerX, centerY, radius, startAngle, endAngle)
    ctx.closePath()
    ctx.fill()
  }

  // reset the Pomodoro Timer
  resetPomodoro = () => {
    // timer according session or break

    var canvas = document.getElementById('draw-circle')
    var context = canvas.getContext('2d')
    var centerX = canvas.width / 2
    var centerY = canvas.height / 2
    var radius = centerX

    // if we time reset redraw canvas
    context.clearRect(0, 0, canvas.width, canvas.height)
    this.setState({
      eAngle: 0
    })

    //('timer is reset manually.')
    context.fillStyle = 'rgba(80, 227, 194, 1)'
    context.arc(centerX, centerY, radius, 0, Math.PI * 2, false)

    context.fill()
  }

  updateReadingDatabase = () => {
    if (!this.state.isExtend) {
      const num =
        this.props.resultUserProjects.data.length === 0
          ? 1
          : this.props.resultUserProjects.data[0].id + 1
      const minsRead = parseInt(this.state.session - this.state.timer / 60, 10)
      const projectSession = {
        id: num,
        timeStart: moment(new Date(this.state.timeStart)).format(),
        timeComplete: moment().format(),
        date: moment().format('l'),
        durationMin: minsRead,
        projectId: this.props.resultMyProjectsPref.sessionData.id,
        projectName: this.props.resultMyProjectsPref.sessionData.projectName,
        issueId: this.props.resultMyProjectsPref.currentIssue.id,
        issueName: this.props.resultMyProjectsPref.currentIssue.issueName,
        mood: 0,
        comment: '',
        projectTag: this.props.resultMyProjectsPref.sessionData.tags,
        isPlan: '0'
      }
      this.setState({
        currentSession: projectSession,
        minsRead: minsRead
      })
      var allData = this.props.resultUserProjects.data
      allData.splice(0, 0, projectSession)
      this.props.resultUserProjects.updateData(allData)
      this.props.resultUserProjects.updateSessionData(projectSession)
    } else {
      const minsRead = parseInt(this.state.session - this.state.timer / 60, 10)
      this.props.resultUserProjects.data[0].durationMin =
        parseInt(this.state.currentSession.durationMin, 10) + minsRead
      this.props.resultUserProjects.data[0].timeComplete = moment().format()
      this.props.resultUserProjects.updateSessionData(
        this.props.resultUserProjects.data[0]
      )
      this.setState({
        currentSession: this.props.resultUserProjects.data[0],
        minsRead: minsRead,
        isExtend: false
      })
    }
    this.setState({ eAngle: 0 })
    this.updateDataPoints(JSON.stringify(this.props.resultUserProjects.data))

    //update store and database: resultMyProjectsPref
    this.props.resultMyProjectsPref.updateTimeSpend(
      this.reCalcIssueMins(this.props.resultUserProjects.sessionData),
      this.props.resultUserProjects.sessionData.projectId,
      this.props.resultUserProjects.sessionData.issueId,
      this.props.resultUserProjects.sessionData.issueName
    )
    this.updateDataPointsMyProjectsPref(
      JSON.stringify(this.props.resultMyProjectsPref.data)
    )
  }

  reCalcIssueMins = s => {
    var mins = 0
    var sessions = this.props.resultUserProjects.data.filter(
      e =>
        e.issueId === s.issueId &&
        e.issueName === s.issueName &&
        e.projectId === s.projectId &&
        e.projectName === s.projectName &&
        e.isPlan !== '1'
    )
    if (sessions && sessions.length > 0) {
      sessions.forEach(e => (mins += parseInt(e.durationMin, 10)))
    }
    return mins
  }

  handleIssueEdit = id => {
    var issues = this.props.resultMyProjectsPref.sessionData.issues
    var index = issues
      .map(x => {
        return x.id
      })
      .indexOf(id)

    var issue = this.props.resultMyProjectsPref.sessionData.issues[index]
    this.props.resultMyProjectsPref.updateIssueData(issue)
    this.setState({ OpenAddIssue: true })
  }

  handleSessionEdit = id => {
    //('clicked edit')
    var allData = this.props.resultUserProjects.data

    var index = allData
      .map(x => {
        return x.id
      })
      .indexOf(id)

    var sessionData = this.props.resultUserProjects.data[index]
    this.props.resultUserProjects.updateSessionData(sessionData)

    if (sessionData.isPlan === '1') {
      isSessionPlan = true
    } else {
      isSessionPlan = false
    }

    this.setState({ OpenAdd: true })
  }

  handleIssueDelete = id => {
    var issues = this.props.resultMyProjectsPref.sessionData.issues
    var index = issues
      .map(x => {
        return x.id
      })
      .indexOf(id)
    issues.splice(index, 1)
    this.props.resultMyProjectsPref.issueData = ''
    this.props.resultMyProjectsPref.sessionData.issues = issues
    this.props.resultMyProjectsPref.updateDataBySession()
    if (this.props.resultMyProjectsPref.data.length === 0) {
      this.updateDataPointsMyProjectsPref(JSON.stringify([]))
    } else {
      this.updateDataPointsMyProjectsPref(
        JSON.stringify(this.props.resultMyProjectsPref.data)
      )
    }
    this.setState({ openDeleteIssue: false })
  }

  handleSessionDelete = (id, date) => {
    //('clicked delete')
    //(id)

    var allData = this.props.resultUserProjects.data

    var index = allData
      .map(x => {
        return x.id
      })
      .indexOf(id)

    var sTmp = this.props.resultUserProjects.data[index]
    // delete this session
    allData.splice(index, 1)
    this.props.resultUserProjects.updateData(allData)
    if (this.props.resultUserProjects.data.length === 0) {
      this.updateDataPoints(JSON.stringify([]))
    } else {
      this.updateDataPoints(JSON.stringify(this.props.resultUserProjects.data))
    }
    if (id === this.state.currentSession.id) {
      this.setState({
        isSessionNow: true
      })
      this.updateState(this.state.session)
    }

    //update store and database: resultMyProjectsPref
    this.props.resultMyProjectsPref.updateTimeSpend(
      this.reCalcIssueMins(sTmp),
      sTmp.projectId,
      sTmp.issueId,
      sTmp.issueName
    )
    this.updateDataPointsMyProjectsPref(
      JSON.stringify(this.props.resultMyProjectsPref.data)
    )

    this.setState({
      OpenView: false,
      openDeleteSession: false
    })
  }

  handleSessionDeleteAll = () => {
    //('delete all')
    this.props.resultUserProjects.updateData([])
    this.updateDataPointsDelAll(JSON.stringify([]))
  }

  // starts the Pomodoro Timer
  manulCompletePomodoro = () => {
    // timer according session or break

    var canvas = document.getElementById('draw-circle')
    var context = canvas.getContext('2d')

    //('Started: ' + moment().calendar())
    this.setState({
      interval: setInterval(
        function() {
          // timer ended
          // change state
          this.setState({
            isSessionNow: !this.state.isSessionNow,
            isPaused: false,
            eAngle: 0
          })
          // clear interval
          clearInterval(this.state.interval)
          // clear canvas
          context.clearRect(0, 0, canvas.width, canvas.height)
        }.bind(this),
        1000
      )
    })

    // write into database
    this.updateReadingDatabase()
  }

  // starts the Pomodoro Timer
  startPomodoro = () => {
    if (this.state.initialStart) {
      this.setState({ timeStart: moment().format() })
    }

    this.setState({ initialStart: false, initialStartTimer: false })

    // timer according session or break
    var timer
    // audio links
    var wav = process.env.PUBLIC_URL + '/oringz-w425.mp3'
    var audio = new Audio(wav)

    var canvas = document.getElementById('draw-circle')
    var context = canvas.getContext('2d')
    var centerX = canvas.width / 2
    var centerY = canvas.height / 2
    var radius = centerX
    var offset

    if (this.state.isSessionNow) {
      offset = 2 * Math.PI / (this.state.session * 60)
      context.strokeStyle = '#00FF00'

      if (this.state.timer > 0) {
        timer = this.state.timer
      } else {
        timer = this.state.session * 60
      }
    }

    // if we time changed redraw canvas
    if (this.state.isUpdated) {
      context.clearRect(0, 0, canvas.width, canvas.height)
      this.setState({
        eAngle: 0
      })
      //('timer is reset.')
    }

    // timer starting
    if (!this.state.isPaused) {
      this.noSleep.enable()
      this.setState({ sleep: 'No Sleep' })
      //('sleep no no')
      //('Started: ' + moment().calendar())
      this.setState({
        interval: setInterval(
          function() {
            // timer not ended
            if (--timer >= 0) {
              context.fillStyle = 'rgba(80, 227, 194, 1)'
              context.arc(centerX, centerY, radius, 0, Math.PI * 2, false)

              context.fill()
              context.beginPath()

              this.drawPieSlice(
                context,
                centerX,
                centerY,
                radius,
                1.5 * Math.PI,
                1.5 * Math.PI + this.state.eAngle,
                'rgba(97, 97, 97, 1)'
              )

              this.setState({
                timer: timer,
                eAngle: this.state.eAngle + offset
              })
            } else {
              this.noSleep.disable()
              this.setState({ sleep: 'Will Sleep' })
              //('sleep yes')
              if (this.state.isSessionNow) {
                // timer ended
                // play audio
                audio.play()
                // change state
                this.setState({
                  isSessionNow: !this.state.isSessionNow,
                  isPaused: false,
                  eAngle: 0
                })
                // clear interval
                clearInterval(this.state.interval)
                // clear canvas
                context.clearRect(0, 0, canvas.width, canvas.height)
                // write into database
                this.updateReadingDatabase()
              }
            }
          }.bind(this),
          1000
        )
      })
    } else {
      this.noSleep.disable()
      this.setState({ sleep: 'Will Sleep' })
      //('sleep yes')
      clearInterval(this.state.interval)
    }

    this.setState({
      isPaused: !this.state.isPaused,
      isUpdated: false
    })
  }

  // display time in minutes and seconds
  displayTime = () => {
    var mins = parseInt(this.state.timer / 60, 10)
    var secs = parseInt(this.state.timer % 60, 10)

    mins = mins < 10 ? '0' + mins : mins
    secs = secs < 10 ? '0' + secs : secs

    return mins + ':' + secs + ' (' + this.state.sleep + ')'
  }

  handleTimeUp = () => {
    this.updateState(this.state.session + 10)
  }

  handleTimeDown = () => {
    this.updateState(this.state.session - 10)
  }

  handleReset = () => {
    this.setState({
      isSessionNow: true
    })
    this.updateState(this.state.session)
  }

  handleNoSleep = () => {
    this.noSleep.enable()
    this.setState({ sleep: 'No Sleep' })
  }

  handleWillSleep = () => {
    this.noSleep.disable()
    this.setState({ sleep: 'Will Sleep' })
  }

  handleResetNew = () => {
    this.setState({
      isExtend: false,
      isSessionNow: true,
      timeStart: moment().format()
    })
    this.updateState(this.state.session)
  }

  handleExtendReset = () => {
    this.setState({
      isExtend: true,
      isSessionNow: true
    })
    this.updateState(this.state.session)
  }

  handleComplete = () => {
    if (parseInt(this.state.session - this.state.timer / 60, 10) < 1) {
      //('0 mins read, so no new record')
      this.handleOpenZero()
      return
    }

    this.setState({ isCompleted: true })
    this.manulCompletePomodoro()
  }

  handleOpenZero = () => {
    this.setState({ openZero: true })
  }

  handleCloseZero = () => {
    this.setState({ openZero: false })
  }

  handleCloseDelAllNo = () => {
    this.setState({ openDelAll: false })
  }

  handleCloseDelAllYes = () => {
    this.handleSessionDeleteAll()
    if (this.props.readProjectsDefault.allDataSets.length === 1) {
      if (this.props.readProjectsDefault.allDataSets[0].dataPoints !== '') {
        //('defualt table is refreshed.')
        this.props.resultUserProjects.updateData(
          JSON.parse(this.props.readProjectsDefault.allDataSets[0].dataPoints)
        )
      }
    }
    this.setState({ openDelAll: false })
  }

  handleOpenDeleteSession = (id, date) => {
    this.props.resultUserProjects.delId = id
    this.props.resultUserProjects.delDate = date
    this.setState({ openDeleteSession: true })
  }

  handleCloseDeleteSessionNo = () => {
    this.setState({ openDeleteSession: false })
  }

  handleOpenDeleteIssue = id => {
    this.props.resultMyProjectsPref.delIssueId = id
    this.setState({ openDeleteIssue: true })
  }

  handleCloseDeleteIssueNo = () => {
    this.setState({ openDeleteIssue: false })
  }

  updateState = newTime => {
    var updateTime = newTime
    // max time in mins 60
    var max = 120
    // min time in mins 1
    var min = 10

    // did update time
    var isUpdated = true

    if (updateTime > max) {
      updateTime = max
    } else if (updateTime < min) {
      updateTime = min
    }

    //
    this.setState({
      session: updateTime,
      eAngle: 0
    })

    this.updateStats(updateTime, this.state.token, isUpdated)
    this.resetPomodoro()
  }

  createDataSet = async dataPoints => {
    //('to create defaultProjects table')
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/login`)
      return
    }
    // if default table is there, refuse to create
    if (
      this.props.resultUserProjects.readingTrackDataSetId !== '' ||
      this.props.readProjectsDefault.allDataSets.length > 0
    ) {
      //('there is already default dataset there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultProjects',
        description: 'Default projects tracking data',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        //('default table created')
        this.props.resultUserProjects.readingTrackDataSetId = createDataSet.id
      }
    })
  }

  createDataSetUserReadingPref = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      // this.props.history.push(`/login`)
      console.log('not logged in')
      return
    }
    // if default projects pref data is there, refuse to create
    if (this.props.readUserProjectsPreference.allDataSets.length > 0) {
      console.log('there is already default user book preference table there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultUserProjectsPreference',
        description: 'defaultUserProjectsPreference',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        console.log('default user projects preference table created')
        this.props.resultUserProjectsPref.datasetId = createDataSet.id
      }
    })
  }

  updateDataPoints = async dataPoints => {
    if (this.props.readProjectsDefault.allDataSets.length === 0) {
      if (this.props.resultUserProjects.readingTrackDataSetId === '') {
        console.log('readProjectsDefault is not created')
        return <div>readProjectsDefault is not created</div>
      }

      try {
        await this.props.UpdateDataSet({
          variables: {
            datasetId: this.props.resultUserProjects.readingTrackDataSetId,
            dataPoints: dataPoints
          },
          update: () => {
            //('Data updated')
            const data = JSON.parse(dataPoints)
            if (data.length > 0) {
              this.setState({ hasHistory: true })
            }
          }
        })
      } catch (e) {
        console.log('There is an error: ' + e)
        if (this.props.readProjectsDefault.allDataSets.length === 1) {
          if (this.props.readProjectsDefault.allDataSets[0].dataPoints !== '') {
            this.props.resultUserProjects.updateData(
              JSON.parse(
                this.props.readProjectsDefault.allDataSets[0].dataPoints
              )
            )
          }
        }
        this.signOut()
      }
    } else {
      try {
        await this.props.UpdateDataSet({
          variables: {
            datasetId: this.props.readProjectsDefault.allDataSets[0].id,
            dataPoints: dataPoints
          },
          update: () => {
            //('Data updated')
            const data = JSON.parse(dataPoints)
            if (data.length > 0) {
              this.setState({ hasHistory: true })
            }
          }
        })
      } catch (e) {
        console.log('There is an error: ' + e)
        if (this.props.readProjectsDefault.allDataSets.length === 1) {
          if (this.props.readProjectsDefault.allDataSets[0].dataPoints !== '') {
            this.props.resultUserProjects.updateData(
              JSON.parse(
                this.props.readProjectsDefault.allDataSets[0].dataPoints
              )
            )
          }
        }
        this.signOut()
      }
    }
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    global.localStorage.removeItem(GC_AUTH_TOKEN)
    this.props.history.push(`/login`)
  }

  updateDataPointsMyProjectsPref = async dataPoints => {
    if (this.props.readMyProjectsPreference.allDataSets.length === 0) {
      if (this.props.resultMyProjectsPref.prefDatasetId === '') {
        return <div>readMyProjectsPreference is not created</div>
      }
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.resultMyProjectsPref.prefDatasetId,
          dataPoints: dataPoints
        },
        update: () => {
          //('Book data updated: readMyProjectsPreference')
        }
      })
    } else {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readMyProjectsPreference.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          //('Book data updated: readMyProjectsPreference')
        }
      })
    }
  }

  updateDataPointsDelAll = async dataPoints => {
    if (this.props.readProjectsDefault.allDataSets.length === 0) {
      //('no default data there')
      return
    }

    await this.props.UpdateDataSet({
      variables: {
        datasetId: this.props.readProjectsDefault.allDataSets[0].id,
        dataPoints: dataPoints
      },
      update: () => {
        //('Data deleted all')
        this.setState({ hasHistory: false })
      }
    })
  }

  handleCompleteIssue = status => {
    if (status === '0') {
      this.props.resultMyProjectsPref.issueData.isCompleted = '1'
    } else {
      this.props.resultMyProjectsPref.issueData.isCompleted = '0'
    }
    this.props.resultMyProjectsPref.updateSessionByIssue()
    this.props.resultMyProjectsPref.updateDataBySession()
    this.updateDataPointsMyProjectsPref(
      JSON.stringify(this.props.resultMyProjectsPref.data)
    )

    this.setState({
      OpenAddIssue: false,
      issueAdd: false
    })
  }

  handleCloseAddIssue = () => {
    //todo
    this.setState({
      OpenAddIssue: false,
      issueAdd: false
    })
  }

  handleCloseAdd = () => {
    if (this.props.readProjectsDefault.allDataSets.length === 1) {
      if (this.props.readProjectsDefault.allDataSets[0].dataPoints !== '') {
        //('defualt table is refreshed.')
        this.props.resultUserProjects.updateData(
          JSON.parse(this.props.readProjectsDefault.allDataSets[0].dataPoints)
        )
      }
    }
    this.props.resultUserProjects.updatesessionsDataByDate(
      this.props.resultUserProjects.sessionData.date
    )

    //update store and database: resultMyProjectsPref
    this.props.resultMyProjectsPref.updateTimeSpend(
      this.reCalcIssueMins(this.props.resultUserProjects.sessionData),
      this.props.resultUserProjects.sessionData.projectId,
      this.props.resultUserProjects.sessionData.issueId,
      this.props.resultUserProjects.sessionData.issueName
    )
    this.updateDataPointsMyProjectsPref(
      JSON.stringify(this.props.resultMyProjectsPref.data)
    )

    isSessionPlan = false

    this.setState({
      OpenAdd: false,
      openTimer: false,
      initialStartTimer: true,
      OpenView: false
    })
    /*
    if (
      this.props.resultUserProjects.sessionsDataByDate &&
      this.props.resultUserProjects.sessionsDataByDate.length > 0
    ) {
      this.setState({ OpenView: true })
    } else {
      this.setState({ OpenView: false })
    } */
  }

  filterIssues = (id, name, issues) => {
    var isIncluded = false
    if (issues && issues.length > 0) {
      issues.forEach(e => {
        if (e.id === id && e.issueName === name) {
          isIncluded = true
        }
      })
      return isIncluded
    } else {
      return false
    }
  }

  render() {
    const { classes } = this.props
    const userId = global.localStorage.getItem(GC_USER_ID)

    if (this.props.readProjectsDefault.loading) {
      return <div>Loading projects data ... </div>
    }

    if (
      this.props.readProjectsDefault &&
      this.props.readProjectsDefault.error
    ) {
      return (
        <div>
          Please refresh! Error: readProjectsDefault -{' '}
          {this.props.readProjectsDefault.error.toString()}
        </div>
      )
    }

    if (this.props.readMyProjectsPreference.loading) {
      return <div>Loading readMyProjectsPreference data ... </div>
    }

    if (
      this.props.readMyProjectsPreference &&
      this.props.readMyProjectsPreference.error
    ) {
      return (
        <div>
          Please refresh! Error: readMyProjectsPreference -{' '}
          {this.props.readMyProjectsPreference.error.toString()}
        </div>
      )
    }

    if (this.props.readUserProjectsPreference.loading) {
      return <div>Loading user projects preference data ... </div>
    }

    if (
      this.props.readUserProjectsPreference &&
      this.props.readUserProjectsPreference.error
    ) {
      return (
        <div>
          Please refresh! Error: readUserProjectsPreference -{' '}
          {this.props.readUserProjectsPreference.error.toString()}
        </div>
      )
    }

    // load projects data
    if (this.props.readProjectsDefault.allDataSets.length === 1) {
      this.props.resultUserProjects.userId = userId
      if (this.props.readProjectsDefault.allDataSets[0].dataPoints) {
        var l = JSON.parse(
          this.props.readProjectsDefault.allDataSets[0].dataPoints
        ).length
        if (l > 0) {
          // store mgt
          if (this.props.resultUserProjects.data.length > 0) {
            if (
              this.props.resultUserProjects.userId !== '' &&
              this.props.resultUserProjects.userId !== userId
            ) {
              this.props.resultUserProjects.updateData(
                JSON.parse(
                  this.props.readProjectsDefault.allDataSets[0].dataPoints
                )
              )
            }
          } else if (this.props.resultUserProjects.data.length === 0) {
            //('defualt table is there.')
            this.props.resultUserProjects.updateData(
              JSON.parse(
                this.props.readProjectsDefault.allDataSets[0].dataPoints
              )
            )
          } else {
            console.log('error')
          }
        } else {
          console.log('there is table, but datapoints length not > 0 ')
          // store mgt
          if (this.props.resultUserProjects.data.length > 0) {
            if (
              this.props.resultUserProjects.userId !== '' &&
              this.props.resultUserProjects.userId !== userId
            ) {
              this.props.resultUserProjects.updateData([])
            }
          }
        }
      } else {
        console.log('there is table, but no datapoints')
        // store mgt
        if (this.props.resultUserProjects.data.length > 0) {
          if (
            this.props.resultUserProjects.userId !== '' &&
            this.props.resultUserProjects.userId !== userId
          ) {
            this.props.resultUserProjects.updateData([])
          }
        }
      }
    } else if (this.props.readProjectsDefault.allDataSets.length === 0) {
      // created?
      if (!this.props.resultUserProjects.created) {
        // create
        //('defualt table to be added')
        this.createDataSet(JSON.stringify(this.props.resultUserProjects.data))
        this.props.resultUserProjects.updateCreated()
        // store mgt
        if (this.props.resultUserProjects.data.length > 0) {
          if (
            this.props.resultUserProjects.userId !== '' &&
            this.props.resultUserProjects.userId !== userId
          ) {
            this.props.resultUserProjects.updateData([])
          }
        }
      }
    } else {
      return (
        <div>
          Error, plesae contact our support team [readProjectsDefault:{' '}
          {this.props.readProjectsDefault.allDataSets.length}]
        </div>
      )
    }

    // load book pref data

    if (this.props.readMyProjectsPreference.allDataSets.length === 1) {
      if (
        this.props.readMyProjectsPreference.allDataSets[0].dataPoints !== ''
      ) {
        var allBooks = JSON.parse(
          this.props.readMyProjectsPreference.allDataSets[0].dataPoints
        )
        var currentBook = allBooks.filter(b => b.isCurrent === '1')
        if (currentBook.length === 1) {
          this.props.resultMyProjectsPref.updateData(allBooks)
          this.props.resultMyProjectsPref.updateSessionData(currentBook[0])
        } else if (currentBook.length > 1) {
          return <div>error: current book is more than 1</div>
        } else if (currentBook.length === 0) {
          this.props.resultMyProjectsPref.updateData(allBooks)
          this.props.resultMyProjectsPref.updateSessionData([])
        }
      }
    } else if (this.props.readMyProjectsPreference.allDataSets.length === 0) {
      if (this.props.resultMyProjectsPref.prefDatasetId === '') {
        this.props.resultMyProjectsPref.updateData([])
        this.props.resultMyProjectsPref.updateSessionData([])
      }
    } else {
      return (
        <div>
          Error, plesae contact our support team [readMyProjectsPreference:{' '}
          {this.props.readMyProjectsPreference.allDataSets.length}]
        </div>
      )
    }

    // load projects pref data

    if (this.props.resultUserProjectsPref.data.length === 0) {
      if (this.props.readUserProjectsPreference.allDataSets.length === 1) {
        if (
          this.props.readUserProjectsPreference.allDataSets[0].dataPoints !== ''
        ) {
          //('default projects pref data is there')
          this.props.resultUserProjectsPref.updateData(
            JSON.parse(
              this.props.readUserProjectsPreference.allDataSets[0].dataPoints
            )
          )
          this.props.resultUserProjectsPref.updateGoal()
        }
      } else if (
        this.props.readUserProjectsPreference.allDataSets.length === 0
      ) {
        if (!this.props.resultUserProjectsPref.created) {
          console.log('create user projects pref default table')
          this.createDataSetUserReadingPref(
            JSON.stringify(this.props.resultUserProjectsPref.data)
          )
          this.props.resultUserProjectsPref.updateCreated()
        }
      } else {
        return (
          <div>
            Error, plesae contact our support team [resultUserProjectsPref:{' '}
            {this.props.readUserProjectsPreference.allDataSets.length}]
          </div>
        )
      }
    }

    var tmpData = this.props.resultUserProjects.data.filter(
      e => e.projectTag === this.props.resultMyProjectsPref.sessionData.tags
    )

    // aggregate projects data to daily
    var dataSessionsByDate = this.getPivotArray(tmpData, 'date', '', '')

    // get this project data
    var tmpDataThisProject = this.props.resultUserProjects.data.filter(
      e =>
        e.projectId === this.props.resultMyProjectsPref.sessionData.id &&
        e.projectName ===
          this.props.resultMyProjectsPref.sessionData.projectName
    )

    // aggregate projects data to daily
    var dataSessionsByDateThisProject = this.getPivotArray(
      tmpDataThisProject,
      'date',
      '',
      ''
    )

    // today panel stats
    var weeklyPagesReadAvg = 0
    var weeklyAvgMins = 0

    var todayPages = 0
    var todayMins = 0

    var todayRecords = dataSessionsByDate.filter(
      r => moment(new Date(r[0])).format('l') === moment().format('l')
    )

    if (todayRecords.length > 0) {
      todayPages = todayRecords[0][3]
      todayMins = todayRecords[0][2]
    }
    /*
    var pagesToGoalToday =
      this.props.resultUserProjectsPref.goal.pagesGoalHigh > 0
        ? this.props.resultUserProjectsPref.goal.pagesGoalHigh - todayPages
        : 0
        */
    var percentGoalToday =
      todayPages * 100 / this.props.resultUserProjectsPref.goal.pagesGoalHigh

    var thisWeekRecords = dataSessionsByDate.filter(
      r =>
        moment(new Date(r[0]))
          .endOf('week')
          .format('l') ===
        moment()
          .endOf('week')
          .format('l')
    )
    if (thisWeekRecords.length > 0) {
      var pagesAll = 0
      var minsAll = 0
      thisWeekRecords.forEach(e => {
        pagesAll += e[3]
        minsAll += e[2]
      })
      weeklyPagesReadAvg = (pagesAll / thisWeekRecords.length).toFixed(0)
      weeklyAvgMins = (minsAll / thisWeekRecords.length).toFixed(0)
    }
    /*
    var pagesToGoalThisWeek =
      this.props.resultUserProjectsPref.goal.pagesGoalHigh > 0
        ? this.props.resultUserProjectsPref.goal.pagesGoalHigh -
          weeklyPagesReadAvg
        : 0 */
    var percentGoal =
      weeklyPagesReadAvg *
      100 /
      this.props.resultUserProjectsPref.goal.pagesGoalHigh

    //current book data
    var currentSessionsData = this.props.resultUserProjects.data.filter(
      e =>
        e.projectId === this.props.resultMyProjectsPref.sessionData.id &&
        this.filterIssues(
          e.issueId,
          e.issueName,
          this.props.resultMyProjectsPref.sessionData.issues
        )
    )

    //sort above data
    currentSessionsData.sort(function(a, b) {
      return new Date(a.timeComplete) - new Date(b.timeComplete)
    })

    // calc project total hours and hours spend
    // add all estimate together (if timespend more than estimate, then add timespend instead)
    var projectTotalMins = 0
    var projectRemainingMins = 0
    var percentMins = 0
    if (
      this.props.resultMyProjectsPref.sessionData &&
      this.props.resultMyProjectsPref.sessionData.issues &&
      this.props.resultMyProjectsPref.sessionData.issues.length > 0
    ) {
      this.props.resultMyProjectsPref.sessionData.issues.forEach(p => {
        var e = parseInt(p.minsEstimate, 10)
        var s = parseInt(p.minsSpend, 10)
        if (p.isCompleted === '0' && e >= s) {
          projectTotalMins += e
          projectRemainingMins += e - s
        } else {
          projectTotalMins += s
        }
      })
      percentMins =
        projectTotalMins > 0 && projectRemainingMins === 0
          ? 100
          : projectTotalMins === 0
            ? 0
            : parseInt(
                (projectTotalMins - projectRemainingMins) *
                  100 /
                  projectTotalMins,
                10
              )
    }

    // add start and end data for burndown chart

    var t = projectTotalMins

    currentSessionsData.forEach(e => {
      e['pageStart'] = t - parseInt(e.durationMin, 10)
      e['pageEnd'] = t
      t = t - parseInt(e.durationMin, 10)
    })

    return (
      <div>
        {this.props.resultMyProjectsPref.sessionData &&
        this.props.resultMyProjectsPref.sessionData.length !== 0 ? (
          <Paper className={classes.paperRootCurrentBook}>
            <Grid container spacing={0}>
              <Grid item className={classes.gridLeft}>
                <div id="bookblock" className={classes.bookBlock}>
                  <ChromeReaderModeIcon className={classes.iconBook} />
                  <Typography
                    variant="body1"
                    id="projectName"
                    style={{
                      paddingLeft: 8,
                      paddingRight: 2,
                      textAlign: 'left',
                      fontSize: 12
                    }}
                  >
                    {this.props.resultMyProjectsPref.sessionData.projectName}
                  </Typography>
                  <Typography
                    variant="caption"
                    id="status"
                    style={{
                      paddingLeft: 8,
                      paddingRight: 8,
                      fontSize: 9,
                      textAlign: 'left'
                    }}
                  >
                    {this.props.resultMyProjectsPref.sessionData.status}
                  </Typography>
                </div>
              </Grid>
              <Grid
                item
                container
                direction="column"
                spacing={0}
                className={classes.gridRightButtons}
              >
                <Grid item>
                  <div style={{ textAlign: 'left', marginTop: 10 }}>
                    <Button
                      onClick={() => this.props.history.push('/projects')}
                      className={classes.iconAllProjects}
                      size="small"
                    >
                      <ChevronRightIcon
                        className={classes.iconBtnCurrentBookRefresh}
                      />{' '}
                      <span style={{ color: 'silver' }}> All Projects</span>
                    </Button>
                  </div>
                  <Typography
                    style={{
                      color: 'grey',
                      fontSize: 14,
                      height: 20,
                      paddingTop: 30
                    }}
                  >
                    {this.props.resultMyProjectsPref.sessionData.status ===
                    'closed'
                      ? 'Closed.'
                      : projectRemainingMins === 0
                        ? 'Remaining Hours: 0'
                        : 'Remaining Hours: ' +
                          (projectRemainingMins / 60).toFixed(1)}
                  </Typography>
                  <div style={{ position: 'relative', top: 8 }}>
                    <Typography style={{ color: 'lightgrey', fontSize: 12 }}>
                      Progress: {percentMins}%{' '}
                      {percentMins === 100 ? (
                        <CheckIcon style={{ color: 'green', fontSize: 12 }} />
                      ) : (
                        ''
                      )}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={percentMins}
                      classes={{
                        colorPrimary: classes.linearColorPrimary,
                        barColorPrimary:
                          percentMins === 100
                            ? classes.linearBarColorPrimaryComplete
                            : classes.linearBarColorPrimary
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        ) : (
          <Paper className={classes.paperRootCurrentBook}>
            <Grid container spacing={0}>
              <Grid item className={classes.gridLeft}>
                <div id="bookblock" className={classes.bookBlock}>
                  <ChromeReaderModeIcon className={classes.iconBook} />
                </div>
              </Grid>
              <Grid
                item
                container
                direction="column"
                spacing={0}
                className={classes.gridRight}
              >
                <Grid item xs>
                  <Typography
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.props.history.push('/projects')}
                  >
                    Choose or create a project to start
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        )}

        {this.props.resultMyProjectsPref.sessionData &&
          this.props.resultMyProjectsPref.sessionData.length !== 0 && (
            <Paper className={classes.paperRootCurrentBookWithoutLength}>
              <div style={{ textAlign: 'left' }}>
                <List dense>
                  {this.props.resultMyProjectsPref.sessionData &&
                    this.props.resultMyProjectsPref.sessionData.issues &&
                    this.props.resultMyProjectsPref.sessionData.issues.map(
                      p => (
                        <ListItem key={p.id}>
                          <ListItemAvatar
                            style={{
                              cursor:
                                p.isCompleted === '1' ? 'auto' : 'pointer',
                              backgroundColor: 'white',
                              boxShadow: '0px 0px 10px #eeeeee'
                            }}
                            onClick={
                              p.isCompleted === '1'
                                ? () => console.log('do nothing')
                                : () => this.handleOpenTimer(p.id)
                            }
                          >
                            <Avatar>
                              {p.isCompleted === '1' ? (
                                <CheckIcon
                                  className={classes.iconBtnCurrentBook}
                                />
                              ) : (
                                <PlayArrowIcon
                                  className={classes.iconBtnCurrentBook}
                                />
                              )}
                            </Avatar>
                          </ListItemAvatar>
                          <div
                            style={{
                              cursor: 'pointer',
                              ineHeight: 1,
                              paddingLeft: 10,
                              width: '90%'
                            }}
                            onClick={() =>
                              this.handleOpenViewByIssue(
                                p.id,
                                this.props.resultMyProjectsPref.sessionData.id,
                                p.issueName
                              )
                            }
                          >
                            <span
                              style={{
                                fontSize: 13,
                                color: 'grey'
                              }}
                            >
                              {p.issueName}
                            </span>
                            <br />
                            {p.isCompleted === '1' ? (
                              <span
                                style={{ fontSize: 10, color: 'lightgrey' }}
                              >
                                Closed. (Spent{' '}
                                {p.minsSpend === 0
                                  ? 0
                                  : (p.minsSpend / 60).toFixed(1)}{' '}
                                hours.)
                              </span>
                            ) : (
                              <span
                                style={{ fontSize: 10, color: 'lightgrey' }}
                              >
                                {p.minsEstimate - p.minsSpend === 0
                                  ? 0
                                  : (
                                      (p.minsEstimate - p.minsSpend) /
                                      60
                                    ).toFixed(1)}{' '}
                                hours remaining | Progress:{' '}
                                {parseInt(p.minsSpend, 10) !== 0 &&
                                p.minsEstimate <= p.minsSpend
                                  ? 100
                                  : parseInt(p.minsSpend, 10) === 0
                                    ? 0
                                    : parseInt(
                                        p.minsSpend * 100 / p.minsEstimate,
                                        10
                                      )}%
                              </span>
                            )}
                            <LinearProgress
                              variant="determinate"
                              value={
                                parseInt(p.minsSpend, 10) !== 0 &&
                                p.minsEstimate <= p.minsSpend
                                  ? 100
                                  : parseInt(p.minsSpend, 10) === 0
                                    ? 0
                                    : p.minsSpend * 100 / p.minsEstimate
                              }
                              classes={{
                                colorPrimary: classes.linearColorPrimary,
                                barColorPrimary:
                                  parseInt(p.minsSpend, 10) !== 0 &&
                                  p.minsEstimate <= p.minsSpend
                                    ? classes.linearBarColorPrimaryComplete
                                    : classes.linearBarColorPrimary
                              }}
                            />
                          </div>
                          <ListItemSecondaryAction>
                            <IconButton
                              aria-label="Edit"
                              onClick={() => this.handleIssueEdit(p.id)}
                            >
                              <EditIcon
                                style={{ color: 'lightgrey', fontSize: 18 }}
                              />
                            </IconButton>
                            <IconButton
                              aria-label="Delete"
                              onClick={() => this.handleOpenDeleteIssue(p.id)}
                            >
                              <DeleteIcon
                                style={{ color: 'lightgrey', fontSize: 18 }}
                              />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                      )
                    )}
                  <ListItem
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.handleOpenAddIssue()}
                  >
                    <ListItemAvatar style={{ backgroundColor: 'white' }}>
                      <Avatar>
                        <AddIcon className={classes.iconBtnCurrentBook} />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Add a task" />
                  </ListItem>
                </List>
              </div>
            </Paper>
          )}

        {this.props.resultMyProjectsPref.sessionData &&
          this.props.resultMyProjectsPref.sessionData.length !== 0 &&
          this.props.resultUserProjects.data.length !== 0 &&
          projectTotalMins > 0 &&
          currentSessionsData.length > 0 && (
            <div>
              <div className={classes.divTodayPanelTitle}>
                <Typography
                  variant="caption"
                  style={{ color: 'lightgrey', fontSize: 15 }}
                >
                  Project: {currentSessionsData[0].projectName}
                </Typography>{' '}
              </div>
              <Paper className={classes.paperCalendarView}>
                <AlchemyReadingCurrentBookBurnDown
                  data={currentSessionsData}
                  width={
                    window.innerWidth < 630 * 1.2
                      ? window.innerWidth
                      : 630 * 1.2
                  }
                  height={
                    window.innerWidth < 630 * 1.2
                      ? window.innerWidth * 0.76
                      : 480 * 1.2
                  }
                  totalPages={projectTotalMins}
                  maxPage={projectRemainingMins}
                  todayMins={todayMins}
                  type={'projectTracker'}
                  goal={this.props.resultUserProjectsPref.goal}
                  action={(d, t) =>
                    t === 'add' ? this.handleOpenAdd(d) : this.handleOpenView(d)
                  }
                />
                <div style={{ textAlign: 'right', paddingRight: 40 }}>
                  <Link
                    style={{ color: 'lightgrey' }}
                    to={`/share/${global.localStorage.getItem(
                      GC_USER_ID
                    )}/projects`}
                  >
                    {' '}
                    Share
                  </Link>
                </div>
              </Paper>
            </div>
          )}

        {this.props.resultMyProjectsPref.sessionData &&
          this.props.resultMyProjectsPref.sessionData.length !== 0 &&
          this.props.resultUserProjects.data.length !== 0 && (
            <div>
              {this.props.resultMyProjectsPref.sessionData.tags ===
                'alchemyHAHA' && (
                <div>
                  <div className={classes.divTodayPanelTitle}>
                    <Typography
                      variant="caption"
                      style={{ color: 'lightgrey', fontSize: 15 }}
                    >
                      Today's Project
                    </Typography>{' '}
                  </div>
                  {this.props.resultUserProjectsPref.goal !== '' ? (
                    <Paper className={classes.paperGoalBlock}>
                      <Grid container justify="center" spacing={16}>
                        <Grid item className={classes.gridLeftCommon}>
                          <div
                            id="todayPanelGrid"
                            className={classes.todayPanelGrid}
                          >
                            <Typography
                              variant="caption"
                              style={{ color: 'lightgrey', fontSize: 15 }}
                            >
                              Today (Hrs)
                            </Typography>

                            {todayMins > 0 ? (
                              <div>
                                <Typography
                                  variant="display1"
                                  style={{
                                    color: 'lightblue',
                                    paddingLeft: 5,
                                    paddingTop: 5,
                                    paddingBottom: 5
                                  }}
                                >
                                  {(todayMins / 60).toFixed(1)}
                                  <IconButton
                                    onClick={() =>
                                      this.handleOpenView(moment().format('l'))
                                    }
                                    className={classes.iconTodayTime}
                                  >
                                    <EditIcon
                                      style={{
                                        color: 'rgba(0, 0, 0, 0.15)',
                                        fontSize: 15
                                      }}
                                    />
                                  </IconButton>
                                </Typography>
                              </div>
                            ) : (
                              <div style={{ height: 67 }}>
                                <IconButton
                                  className="btn btn-default btn-style"
                                  onClick={() =>
                                    this.handleOpenTimer(
                                      this.props.resultMyProjectsPref
                                        .sessionData.issues[0]
                                    )
                                  }
                                >
                                  <AddIcon
                                    style={{ color: 'lightgrey', fontSize: 36 }}
                                  />
                                </IconButton>
                              </div>
                            )}
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 10 }}
                            >
                              {
                                this.props.resultUserProjectsPref.goal
                                  .pagesGoalHigh
                              }-Page Daily Goal
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={percentGoalToday}
                              classes={{
                                colorPrimary: classes.linearColorPrimary,
                                barColorPrimary:
                                  percentGoalToday >= 100
                                    ? classes.linearBarColorPrimaryComplete
                                    : classes.linearBarColorPrimary
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid item className={classes.gridLeftCommon}>
                          <div
                            id="todayPanelGridRight"
                            className={classes.todayPanelGrid}
                          >
                            <Typography
                              variant="caption"
                              style={{ color: 'lightgrey', fontSize: 14 }}
                            >
                              This Week Avg
                            </Typography>

                            {weeklyAvgMins > 0 ? (
                              <div>
                                <Typography
                                  variant="display1"
                                  style={{
                                    color: 'rgba(168, 169, 255,0.5)',
                                    padding: 5
                                  }}
                                >
                                  {weeklyPagesReadAvg}
                                </Typography>
                              </div>
                            ) : (
                              <div style={{ height: 67 }}>
                                <Typography
                                  variant="display1"
                                  style={{
                                    color: 'rgba(0, 0, 0, 0.05)',
                                    padding: 5
                                  }}
                                >
                                  N.A.
                                </Typography>
                              </div>
                            )}
                            {this.props.resultUserProjectsPref.goal === '' ? (
                              <div>
                                <Button className={classes.button}>
                                  <span style={{ color: 'lightgrey' }}>
                                    Add Goal
                                  </span>
                                </Button>
                              </div>
                            ) : (
                              <div>
                                <Typography
                                  style={{ color: 'lightgrey', fontSize: 10 }}
                                >
                                  {
                                    this.props.resultUserProjectsPref.goal
                                      .pagesGoalHigh
                                  }-Page Weekly Avg
                                </Typography>
                                <LinearProgress
                                  variant="determinate"
                                  value={percentGoal}
                                  classes={{
                                    colorPrimary: classes.linearColorPrimary,
                                    barColorPrimary:
                                      percentGoal >= 100
                                        ? classes.linearBarColorPrimaryComplete
                                        : classes.linearBarColorPrimaryGoal
                                  }}
                                />{' '}
                              </div>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    </Paper>
                  ) : (
                    ''
                  )}{' '}
                </div>
              )}

              {this.props.resultMyProjectsPref.sessionData.tags ===
                'alchemyHAHA' && (
                <div>
                  <div className={classes.divTodayPanelTitle}>
                    <Typography
                      variant="caption"
                      style={{ color: 'lightgrey', fontSize: 15 }}
                    >
                      Weekly Project
                    </Typography>
                    <Typography
                      variant="caption"
                      style={{
                        color: 'lightgrey',
                        fontSize: 12,
                        paddingTop: 10
                      }}
                    >
                      <span
                        style={{
                          color: 'white',
                          backgroundColor: 'rgba(228,228,228,.7)',
                          fontSize: 18
                        }}
                      >
                        ★
                      </span>{' '}
                      10+ pages{' '}
                      <span
                        style={{
                          color: 'yellow',
                          backgroundColor: 'rgba(228,228,228,.7)',
                          fontSize: 18
                        }}
                      >
                        ★
                      </span>{' '}
                      20+ pages{' '}
                      <span
                        style={{
                          color: 'papayawhip',
                          backgroundColor: 'rgba(228,228,228,.7)',
                          fontSize: 18
                        }}
                      >
                        ★
                      </span>{' '}
                      30+ pages
                    </Typography>
                  </div>
                  <Paper className={classes.paperCalendarView}>
                    <AlchemyReadingWeeklyView
                      data={dataSessionsByDate}
                      width={
                        window.innerWidth < 630 * 1.2
                          ? window.innerWidth
                          : 630 * 1.2
                      }
                      height={
                        window.innerWidth < 630 * 1.2
                          ? window.innerWidth * 0.76
                          : 480 * 1.2
                      }
                      type={'readingTracker'}
                      goal={this.props.resultUserProjectsPref.goal}
                      action={(d, t) =>
                        t === 'add'
                          ? this.handleOpenAdd(d)
                          : this.handleOpenView(d)
                      }
                    />
                  </Paper>
                </div>
              )}

              <div>
                <div className={classes.divTodayPanelTitle}>
                  <Typography
                    variant="caption"
                    style={{ color: 'lightgrey', fontSize: 15 }}
                  >
                    Monthly Streak{' '}
                    <Button
                      onClick={() => this.handleStreakSwitch()}
                      className={
                        this.state.isStreakProject
                          ? classes.iconAllProjectsDisabled
                          : classes.iconAllProjects
                      }
                      size="small"
                      disabled={this.state.isStreakProject}
                    >
                      <span
                        style={{
                          color: this.state.isStreakProject ? 'grey' : 'silver'
                        }}
                      >
                        {' '}
                        {
                          this.props.resultMyProjectsPref.sessionData
                            .projectName
                        }
                      </span>
                    </Button>{' '}
                    <Button
                      onClick={() => this.handleStreakSwitch()}
                      className={
                        !this.state.isStreakProject
                          ? classes.iconAllProjectsDisabled
                          : classes.iconAllProjects
                      }
                      size="small"
                      disabled={!this.state.isStreakProject}
                    >
                      <span
                        style={{
                          color: !this.state.isStreakProject ? 'grey' : 'silver'
                        }}
                      >
                        {' '}
                        {this.props.resultMyProjectsPref.sessionData.tags}
                      </span>
                    </Button>
                  </Typography>
                </div>
                <Paper className={classes.paperCalendarView}>
                  <AlchemyReadingCalendar
                    data={
                      this.state.isStreakProject
                        ? dataSessionsByDateThisProject
                        : dataSessionsByDate
                    }
                    width={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth * 1.24
                        : 630 * 1.2
                    }
                    height={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth * 1.24 * 0.76
                        : 480 * 1.2
                    }
                    type={'readingTracker'}
                    goal={this.props.resultUserProjectsPref.goal}
                    action={(d, t) =>
                      t === 'add'
                        ? this.handleOpenAdd(d)
                        : this.handleOpenView(d)
                    }
                  />
                </Paper>
              </div>

              {this.props.resultMyProjectsPref.sessionData.tags ===
                'alchemyHAHA' && (
                <div>
                  <div className={classes.divTodayPanelTitle}>
                    <Typography
                      variant="caption"
                      style={{ color: 'lightgrey', fontSize: 15 }}
                    >
                      Weekly Average Trend
                    </Typography>
                    <Typography
                      variant="caption"
                      style={{
                        color: 'lightgrey',
                        fontSize: 12,
                        paddingTop: 10
                      }}
                    >
                      <span
                        style={{ color: 'rgba(234,234,255,1', fontSize: 14 }}
                      >
                        ⬤
                      </span>{' '}
                      Speed (pages / hour){' '}
                      <span
                        style={{ color: 'rgba(196,240,196,1', fontSize: 24 }}
                      >
                        ■
                      </span>{' '}
                      pages read / day (weekly avg)
                    </Typography>
                  </div>
                  <Paper className={classes.paperCalendarView}>
                    <AlchemyReadingWeeklyAvg
                      data={dataSessionsByDate}
                      width={
                        window.innerWidth < 630 * 1.2
                          ? window.innerWidth
                          : 630 * 1.2
                      }
                      height={
                        window.innerWidth < 630 * 1.2
                          ? window.innerWidth * 0.76
                          : 480 * 1.2
                      }
                      type={'readingTracker'}
                      goal={this.props.resultUserProjectsPref.goal}
                      action={(d, t) =>
                        t === 'add'
                          ? this.handleOpenAdd(d)
                          : this.handleOpenView(d)
                      }
                    />
                  </Paper>
                </div>
              )}
            </div>
          )}

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.OpenAdd}
          onClose={this.handleCloseAdd}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          <Paper className={classes.paperAddTodayMoreInfo}>
            <div id="clearBtnBedTime" className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleCloseAdd}
                >
                  <ClearIcon className={classes.iconClear} />
                </IconButton>
              </div>
              <List>
                <ListItem className={classes.listItemSleepTimeComplete}>
                  <ListItemIcon>
                    <TimelapseIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="durationMin"
                    label="Minutes spent"
                    className={classes.textField}
                    value={
                      this.props.resultUserProjects.sessionData.durationMin
                    }
                    onChange={this.handleChange('durationMin')}
                    margin="normal"
                  />
                </ListItem>
                <ListItem className={classes.modalContentSmallTime}>
                  <ListItemIcon>
                    <DateRangeIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="date"
                    label="Date"
                    type="date"
                    defaultValue={moment(
                      this.props.resultUserProjects.sessionData.date,
                      'l'
                    ).format('YYYY-MM-DD')}
                    onChange={this.handleChange('date')}
                    className={classes.textFieldMedium}
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall
                    }}
                  />
                  <ListItemIcon>
                    <AlarmOnIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="timeStart"
                    label="Start"
                    type="time"
                    defaultValue={moment(
                      new Date(
                        this.props.resultUserProjects.sessionData.timeStart
                      )
                    ).format('HH:mm')}
                    onChange={this.handleChange('timeStart')}
                    className={classes.textFieldSmall}
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall,
                      step: 300 // 5 min
                    }}
                  />
                  <ListItemIcon>
                    <AlarmOnIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="timeComplete"
                    label="End"
                    type="time"
                    defaultValue={moment(
                      new Date(
                        this.props.resultUserProjects.sessionData.timeComplete
                      )
                    ).format('HH:mm')}
                    onChange={this.handleChange('timeComplete')}
                    className={classes.textFieldSmall}
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall,
                      step: 300 // 5 min
                    }}
                  />
                </ListItem>
                <ListItem className={classes.modalContent}>
                  <ListItemIcon>
                    <SentimentSatisfiedIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <FormControl className={classes.textField}>
                    <InputLabel htmlFor="mood">Mood</InputLabel>
                    <Select
                      native
                      value={this.props.resultUserProjects.sessionData.mood}
                      onChange={this.handleChange('mood')}
                      inputProps={{
                        name: 'mood',
                        id: 'mood'
                      }}
                    >
                      <option value="" />
                      <option value={10}>:)</option>
                      <option value={20}>:|</option>
                      <option value={30}>:(</option>
                    </Select>
                  </FormControl>
                </ListItem>
                <ListItem className={classes.modalContentSmallTime}>
                  <ListItemIcon>
                    <AssignmentIcon className={classes.iconSleepAtTimeDate} />
                  </ListItemIcon>
                  <TextField
                    id="projectName"
                    label="Project Name"
                    className={classes.textFieldMedium}
                    value={
                      this.props.resultUserProjects.sessionData.projectName
                    }
                    onChange={this.handleChange('projectName')}
                    margin="normal"
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall
                    }}
                  />
                  <ListItemIcon>
                    <BookmarkBorderIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="issueName"
                    label="Task"
                    className={classes.textFieldMedium}
                    value={this.props.resultUserProjects.sessionData.issueName}
                    onChange={this.handleChange('issueName')}
                    margin="normal"
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall
                    }}
                  />
                </ListItem>
                <ListItem className={classes.listItemSleepTimeComplete}>
                  <ListItemIcon>
                    <CommentIcon className={classes.iconSleepScore} />
                  </ListItemIcon>
                  <TextField
                    id="comment"
                    label="Commment"
                    multiline
                    value={this.state.comment}
                    onChange={this.handleChange('comment')}
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                  />
                  <IconButton
                    onClick={this.saveComment}
                    disabled={!this.state.isCommented}
                    className={classes.icon}
                    size="small"
                  >
                    <CheckIcon
                      style={{
                        color: this.state.isCommented ? 'blue' : 'lightgrey',
                        fontSize: 20
                      }}
                    />
                  </IconButton>
                </ListItem>

                <ListItem className={classes.modalContentDone}>
                  <ListItemText />
                  <Button
                    onClick={this.handleCloseAdd}
                    className={classes.iconBtnCheck}
                    size="small"
                  >
                    {' '}
                    <span style={{ color: 'grey', fontSize: 15 }}>
                      {isSessionPlan ? 'Plan' : 'Done'}
                    </span>
                    <ChevronRightIcon
                      style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                    />
                  </Button>
                </ListItem>
              </List>
            </div>
          </Paper>
        </Modal>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.OpenAddIssue}
          onClose={this.handleCloseAddIssue}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          <Paper className={classes.paperAddTodayMoreInfo}>
            <div id="clearBtnBedTime" className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleCloseAddIssue}
                >
                  <ClearIcon className={classes.iconClear} />
                </IconButton>
              </div>
              <List>
                <ListItem className={classes.listItemSleepTimeComplete}>
                  <ListItemIcon>
                    <TimelapseIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="issueName"
                    label="Task"
                    className={classes.textField}
                    defaultValue={
                      this.props.resultMyProjectsPref.issueData.issueName
                    }
                    onChange={this.handleChangeIssue('issueName')}
                    margin="normal"
                  />
                </ListItem>
                <ListItem className={classes.listItemSleepTimeComplete}>
                  <ListItemIcon>
                    <TimelapseIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="issueDescription"
                    label="Description"
                    className={classes.textField}
                    defaultValue={
                      this.props.resultMyProjectsPref.issueData.issueDescription
                    }
                    onChange={this.handleChangeIssue('issueDescription')}
                    margin="normal"
                  />
                </ListItem>

                <ListItem className={classes.modalContentSmallTime}>
                  <ListItemIcon>
                    <DateRangeIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="datePlanned"
                    label="Plan Date"
                    type="date"
                    defaultValue={moment(
                      this.props.resultMyProjectsPref.issueData.datePlanned,
                      'l'
                    ).format('YYYY-MM-DD')}
                    onChange={this.handleChangeIssue('date')}
                    className={classes.textFieldMedium}
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall
                    }}
                  />
                  <ListItemIcon>
                    <AlarmOnIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="minsEstimate"
                    label="Hours Estimate"
                    className={classes.textFieldMedium}
                    defaultValue={
                      !this.props.resultMyProjectsPref.issueData.minsEstimate ||
                      parseInt(
                        this.props.resultMyProjectsPref.issueData.minsEstimate,
                        10
                      ) === 0
                        ? ''
                        : (
                            parseInt(
                              this.props.resultMyProjectsPref.issueData
                                .minsEstimate,
                              10
                            ) / 60
                          ).toFixed(1)
                    }
                    onChange={this.handleChangeIssue('minsEstimate')}
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall
                    }}
                  />
                </ListItem>
                <ListItem className={classes.modalContentDone}>
                  <ListItemText />
                  {!this.state.issueAdd && (
                    <Button
                      onClick={() =>
                        this.handleCompleteIssue(
                          this.props.resultMyProjectsPref.issueData.isCompleted
                        )
                      }
                      className={classes.iconBtnCheck}
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        {this.props.resultMyProjectsPref.issueData
                          .isCompleted === '1'
                          ? 'Reopen'
                          : 'Complete'}
                      </span>
                      <CheckIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                    </Button>
                  )}
                  <Button
                    onClick={this.handleCloseAddIssue}
                    className={classes.iconBtnCheck}
                    size="small"
                  >
                    {' '}
                    <span style={{ color: 'grey', fontSize: 15 }}>Done</span>
                    <ChevronRightIcon
                      style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                    />
                  </Button>
                </ListItem>
              </List>
            </div>
          </Paper>
        </Modal>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openZero}
          onClose={this.handleCloseZero}
        >
          <div className={classes.modalZero}>
            <Typography variant="body1" id="modal-title">
              Please read more than 1 min.{' '}
              <span role="img" aria-label="projects">
                {' '}
                📖
              </span>{' '}
              Enjoy your projects!
            </Typography>
            <br />
            <Button
              onClick={this.handleCloseZero}
              className={classes.icon}
              size="small"
            >
              OK
            </Button>
          </div>
        </Modal>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openDeleteIssue}
          onClose={this.handleCloseDeleteIssueNo}
        >
          <div className={classes.modalZero}>
            <Typography variant="body1" id="modal-title">
              Are you sure to delete this task?
            </Typography>
            <br />
            <Button
              onClick={() =>
                this.handleIssueDelete(
                  this.props.resultMyProjectsPref.delIssueId
                )
              }
              className={classes.icon}
              size="small"
            >
              Yes
            </Button>
            <Button
              onClick={this.handleCloseDeleteIssueNo}
              className={classes.icon}
              size="small"
            >
              No
            </Button>
          </div>
        </Modal>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openDeleteSession}
          onClose={this.handleCloseDeleteSessionNo}
        >
          <div className={classes.modalZero}>
            <Typography variant="body1" id="modal-title">
              Are you sure to delete this session?
            </Typography>
            <br />
            <Button
              onClick={() =>
                this.handleSessionDelete(
                  this.props.resultUserProjects.delId,
                  this.props.resultUserProjects.delDate
                )
              }
              className={classes.icon}
              size="small"
            >
              Yes
            </Button>
            <Button
              onClick={this.handleCloseDeleteSessionNo}
              className={classes.icon}
              size="small"
            >
              No
            </Button>
          </div>
        </Modal>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openDelAll}
          onClose={this.handleCloseDelAllNo}
        >
          <div className={classes.modalZero}>
            <Typography variant="body1" id="modal-title">
              Are you sure to delete all?
            </Typography>
            <br />
            <Button
              onClick={this.handleCloseDelAllYes}
              className={classes.icon}
              size="small"
            >
              Yes
            </Button>
            <Button
              onClick={this.handleCloseDelAllNo}
              className={classes.icon}
              size="small"
            >
              No
            </Button>
          </div>
        </Modal>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openTimer}
          onClose={this.handleCloseTimer}
          className={classes.modalAddTodayDark}
          disableBackdropClick
          disableAutoFocus
        >
          <div className={classes.paperAddToday}>
            <div id={this.state.token} className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                {!this.state.isPaused && (
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleCloseTimer}
                  >
                    <ClearIcon className={classes.iconClearDark} />
                  </IconButton>
                )}
              </div>
              <div style={{ height: 100, width: '100%', textAlign: 'center' }}>
                {this.state.isSessionNow ? (
                  this.state.isPaused ? (
                    <div>
                      <div>
                        <IconButton className="btn btn-default btn-style" />
                      </div>
                      <Button
                        onClick={this.startPomodoro}
                        className={classes.iconDark}
                        size="small"
                      >
                        <span style={{ fontSize: 15, color: 'lightgrey' }}>
                          Pause
                        </span>
                      </Button>
                    </div>
                  ) : this.state.eAngle === 0 ? (
                    <div>
                      <div style={{ height: 38 }}>
                        <IconButton
                          onClick={this.handleTimeDown}
                          disabled={this.state.isPaused}
                          className={classes.iconSetDark}
                        >
                          <RemoveIcon />
                        </IconButton>

                        <span style={{ fontSize: 15, color: 'lightgrey' }}>
                          {this.state.session} mins
                        </span>

                        <IconButton
                          onClick={this.handleTimeUp}
                          disabled={this.state.isPaused}
                          className={classes.iconSetDark}
                        >
                          <AddIcon />
                        </IconButton>
                      </div>
                      <Button
                        onClick={() => this.handleOpenAdd(moment().format('l'))}
                        className={classes.iconDark}
                        size="small"
                      >
                        <span style={{ fontSize: 15, color: 'lightgrey' }}>
                          Manually Add
                        </span>
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <div style={{ height: 38 }}>
                        <IconButton className="btn btn-default btn-style" />
                      </div>
                      <Button
                        onClick={this.startPomodoro}
                        className={classes.iconDark}
                        size="small"
                      >
                        <span style={{ fontSize: 15, color: 'lightgrey' }}>
                          Continue
                        </span>
                      </Button>
                    </div>
                  )
                ) : (
                  ''
                )}
              </div>
            </div>

            <div id="timer" className={classes.centerBlock}>
              <canvas id="draw-circle" width="250" height="250" />
              <div id="pause" className={classes.innerWrapTimer}>
                {this.state.isSessionNow ? (
                  this.state.isPaused ? (
                    <IconButton
                      onClick={this.startPomodoro}
                      className={classes.iconPause}
                      disableRipple
                      size="large"
                    >
                      <PauseIcon
                        className={classes.iconBigButtons}
                        style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                      />
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={this.startPomodoro}
                      className={classes.iconPause}
                      disableRipple
                      size="large"
                    >
                      <PlayArrowIcon
                        id="timerPlay"
                        className={classes.iconBigButtons}
                        style={{
                          color: this.state.initialStart
                            ? 'rgba(80, 227, 194, 1)'
                            : 'rgba(255, 255, 255, 0.8)'
                        }}
                      />
                    </IconButton>
                  )
                ) : (
                  <h2 id="title-state" className={classes.innerWrapTimerEmoji}>
                    <span role="img" aria-label="projects">
                      ✅ 📖
                    </span>
                  </h2>
                )}
              </div>

              <div className={classes.innerWrapTimerText}>
                <div id="curr-time">
                  {this.state.isSessionNow ? (
                    this.displayTime()
                  ) : this.state.isExtend ? (
                    <span
                      style={{
                        fontSize: 15,
                        position: 'relative',
                        top: -80,
                        color: 'lightgrey'
                      }}
                    >
                      {' '}
                      You read
                      {this.state.minsRead} mins more this session.{' '}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: 15,
                        position: 'relative',
                        top: -80,
                        color: 'lightgrey'
                      }}
                    >
                      You read {this.state.minsRead} mins this session.
                    </span>
                  )}
                  {this.state.isSessionNow ? (
                    ''
                  ) : (
                    <IconButton
                      onClick={() =>
                        this.handleSessionEdit(this.state.currentSession.id)
                      }
                      className={classes.iconEdit}
                      size="small"
                    >
                      <EditIcon style={{ color: 'lightgrey', fontSize: 20 }} />
                    </IconButton>
                  )}
                  {this.state.isSessionNow ? (
                    ''
                  ) : (
                    <div style={{ textAlign: 'left' }}>
                      <List>
                        <ListItem className={classes.modalContentInputComment}>
                          <ListItemIcon>
                            <SentimentSatisfiedIcon
                              className={classes.editIconsLight}
                            />
                          </ListItemIcon>
                          <FormControl className={classes.formControl}>
                            <InputLabel
                              htmlFor="mood"
                              style={{ color: 'lightgrey' }}
                            >
                              Mood
                            </InputLabel>
                            <Select
                              native
                              value={
                                this.props.resultUserProjects.sessionData.mood
                              }
                              onChange={this.handleChange('mood')}
                              inputProps={{
                                name: 'mood',
                                id: 'mood'
                              }}
                              className={classes.textFieldColor}
                            >
                              <option value="" />
                              <option value={10}>:)</option>
                              <option value={20}>:|</option>
                              <option value={30}>:(</option>
                            </Select>
                          </FormControl>
                        </ListItem>
                        <ListItem className={classes.modalContentInputComment}>
                          <ListItemIcon>
                            <CommentIcon className={classes.editIconsLight} />
                          </ListItemIcon>
                          <TextField
                            id="commentAdd"
                            label="Comment"
                            value={this.state.comment}
                            onChange={this.handleChange('comment')}
                            margin="normal"
                            InputProps={{
                              className: classes.textFieldColor
                            }}
                            InputLabelProps={{
                              className: classes.textFieldTimeTiny
                            }}
                          />
                          <IconButton
                            onClick={this.saveComment}
                            disabled={!this.state.isCommented}
                            className={classes.iconDark}
                            size="small"
                          >
                            <CheckIcon
                              style={{
                                color: this.state.isCommented
                                  ? 'lightblue'
                                  : 'lightgrey',
                                fontSize: 24
                              }}
                            />
                          </IconButton>
                        </ListItem>
                      </List>
                      <Typography
                        variant="caption"
                        id="modal-title"
                        style={{
                          paddingLeft: 130,
                          color: 'grey',
                          position: 'relative',
                          top: -120
                        }}
                      >
                        Completed on{' '}
                        {moment(
                          new Date(this.state.currentSession.timeComplete)
                        ).calendar()}
                      </Typography>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {this.state.isSessionNow ? (
              this.state.eAngle === 0 ? (
                ''
              ) : (
                <div id="buttons" className={classes.centerBlockBtns}>
                  <Button
                    onClick={this.handleComplete}
                    disabled={this.state.isPaused}
                    className={classes.iconDark}
                    size="small"
                  >
                    <CheckIcon style={{ color: 'lightgrey' }} />
                  </Button>
                  <Button
                    onClick={this.handleReset}
                    disabled={this.state.isPaused}
                    className={classes.iconDark}
                    size="small"
                  >
                    <ReplayIcon style={{ color: 'lightgrey' }} />
                  </Button>
                  {this.state.sleep === 'Will Sleep' ? (
                    <Button
                      onClick={() => this.handleNoSleep()}
                      disabled={this.state.isPaused}
                      className={classes.iconDark}
                      size="small"
                    >
                      <VisibilityOffIcon style={{ color: 'lightgrey' }} />
                    </Button>
                  ) : (
                    <Button
                      onClick={() => this.handleWillSleep()}
                      disabled={this.state.isPaused}
                      className={classes.iconDark}
                      size="small"
                    >
                      <VisibilityIcon style={{ color: 'lightgrey' }} />
                    </Button>
                  )}
                </div>
              )
            ) : (
              <div id="buttonsed" className={classes.centerBlockBtns}>
                <Button
                  onClick={this.handleExtendReset}
                  className={classes.iconDark}
                  size="small"
                >
                  <span style={{ fontSize: 15, color: 'lightgrey' }}>
                    Extend
                  </span>
                  <AddIcon style={{ color: 'lightgrey' }} />
                </Button>
                <Button
                  onClick={this.handleResetNew}
                  className={classes.iconDark}
                  size="small"
                >
                  <span style={{ fontSize: 15, color: 'lightgrey' }}>
                    New Session
                  </span>
                  <PlayArrowIcon style={{ color: 'lightgrey' }} />
                </Button>
                <Button
                  onClick={this.handleCloseTimer}
                  className={classes.iconDark}
                  size="small"
                >
                  <span style={{ fontSize: 15, color: 'lightgrey' }}>Done</span>
                  <ChevronRightIcon style={{ color: 'lightgrey' }} />
                </Button>
              </div>
            )}
            {this.state.initialStartTimer && (
              <Paper className={classes.paperRootCurrentBookDark}>
                <Grid container spacing={0}>
                  <Grid item className={classes.gridLeftDark}>
                    <div id="bookblock" className={classes.bookBlock}>
                      <ChromeReaderModeIcon className={classes.iconBook} />
                      <Typography
                        variant="body1"
                        id="projectName"
                        style={{
                          paddingLeft: 8,
                          paddingRight: 2,
                          textAlign: 'left',
                          fontSize: 12,
                          color: 'silver'
                        }}
                      >
                        {
                          this.props.resultMyProjectsPref.sessionData
                            .projectName
                        }
                      </Typography>
                      <Typography
                        variant="caption"
                        id="status"
                        style={{
                          paddingLeft: 8,
                          paddingRight: 8,
                          fontSize: 9,
                          textAlign: 'left',
                          color: 'darkgray'
                        }}
                      >
                        {this.props.resultMyProjectsPref.sessionData.tags}
                      </Typography>
                    </div>
                    <div style={{ textAlign: 'left', marginTop: 10 }}>
                      <IconButton
                        onClick={() => this.props.history.push('/projects')}
                        className={classes.iconTinyDark}
                        size="small"
                      >
                        <RefreshIcon
                          className={classes.iconBtnCurrentBookRefresh}
                        />
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid
                    item
                    container
                    direction="column"
                    spacing={0}
                    className={classes.gridRightButtons}
                  >
                    <Grid item>
                      <IconButton />
                      <br />
                      <Typography
                        style={{
                          color: 'lightgrey',
                          fontSize: 14,
                          height: 20,
                          paddingTop: 10
                        }}
                      >
                        {this.props.resultMyProjectsPref.currentIssue.issueName}
                      </Typography>
                      <div style={{ position: 'relative', top: 8 }}>
                        <Typography style={{ color: 'grey', fontSize: 12 }}>
                          Progress:{' '}
                          {this.props.resultMyProjectsPref.currentIssuePercent}%{' '}
                          {this.props.resultMyProjectsPref
                            .currentIssuePercent >= 100 ? (
                            <CheckIcon
                              style={{ color: 'green', fontSize: 12 }}
                            />
                          ) : (
                            ''
                          )}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={
                            this.props.resultMyProjectsPref.currentIssuePercent
                          }
                          classes={{
                            colorPrimary: classes.linearColorPrimary,
                            barColorPrimary:
                              this.props.resultMyProjectsPref
                                .currentIssuePercent >= 100
                                ? classes.linearBarColorPrimaryComplete
                                : classes.linearBarColorPrimary
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            )}
          </div>
        </Modal>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.OpenView}
          onClose={this.handleCloseView}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          <Paper className={classes.paperAddToday}>
            <div id="GetUpTime" className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleCloseView}
                >
                  <ClearIcon className={classes.iconClear} />
                </IconButton>
              </div>
              <List>
                {this.props.resultUserProjects.sessionsDataByDate.map(s => (
                  <List key={s.id}>
                    <ListItem key={s.id} className={classes.listItemGetUpTime}>
                      <ListItemIcon>
                        <ChromeReaderModeIcon
                          className={classes.iconGetUpTimeView}
                        />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.weightText}
                        primary={
                          s.timeStart === ''
                            ? moment(new Date(s.timeComplete)).format('HH:mm')
                            : moment(new Date(s.timeStart)).format('HH:mm') +
                              '~' +
                              moment(new Date(s.timeComplete)).format('HH:mm')
                        }
                        classes={{
                          primary: classes.textGetUpTimeView,
                          secondary: classes.textGetUpDate
                        }}
                        secondary={'On ' + moment(new Date(s.date)).format('l')}
                      />
                      <IconButton
                        onClick={() => this.handleSessionEdit(s.id)}
                        className={classes.iconBtnCheck}
                        size="small"
                      >
                        <EditIcon
                          style={{
                            color: 'lightgrey',
                            fontSize: 20
                          }}
                        />
                      </IconButton>
                      <IconButton
                        onClick={() =>
                          this.handleOpenDeleteSession(s.id, s.date)
                        }
                        className={classes.iconBtnCheck}
                        size="small"
                      >
                        <DeleteIcon
                          style={{
                            color: 'lightgrey',
                            fontSize: 20
                          }}
                        />
                      </IconButton>
                    </ListItem>

                    {(s.durationMin ||
                      s.pages ||
                      s.projectName ||
                      s.isPlan) && (
                      <ListItem
                        key={`sessiodetail-${s.id}`}
                        className={classes.listItemSessionView}
                      >
                        {s.isPlan === '1' && (
                          <Paper className={classes.paperWidget}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              Plan
                            </Typography>
                          </Paper>
                        )}
                        {s.durationMin !== '' && (
                          <Paper className={classes.paperWidget}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {s.durationMin}
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Mins
                            </Typography>
                          </Paper>
                        )}
                        {s.projectName !== '' && (
                          <Paper className={classes.paperWidget}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {s.issueName}
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              {s.projectName}
                            </Typography>
                          </Paper>
                        )}
                      </ListItem>
                    )}

                    {(s.mood || s.comment) && (
                      <ListItem
                        key={`sessioninfo-${s.id}`}
                        className={classes.listItemSessionView}
                      >
                        {s.mood !== 0 && (
                          <div className={classes.divWidgetMood}>
                            <Paper className={classes.paperWidgetMood}>
                              <Typography
                                style={{ color: 'dimgrey', fontSize: 18 }}
                              >
                                {s.mood === '10'
                                  ? ':)'
                                  : s.mood === '20'
                                    ? ':|'
                                    : this.props.resultUserProjects
                                        .sessionsDataByDate[0].mood === '30'
                                      ? ':('
                                      : ''}
                              </Typography>
                            </Paper>
                          </div>
                        )}

                        {s.comment !== '' && (
                          <Paper className={classes.paperWidgetComment}>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Comment
                            </Typography>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {s.comment}
                            </Typography>
                          </Paper>
                        )}
                      </ListItem>
                    )}
                  </List>
                ))}
              </List>
              <div className={classes.divAddModalButton}>
                <IconButton
                  className={classes.iconBtnCheckAdd}
                  onClick={() =>
                    this.handleOpenAddPlanInIssue(
                      this.props.resultUserProjects.issueId
                    )
                  }
                >
                  <span style={{ color: 'lightgrey', fontSize: 16 }}>Plan</span>
                </IconButton>
                <IconButton
                  className={classes.iconBtnCheckAdd}
                  onClick={() =>
                    this.handleOpenAddInIssue(
                      this.props.resultUserProjects.issueId
                    )
                  }
                >
                  <AddIcon className={classes.iconClear} />
                </IconButton>
              </div>
            </div>
          </Paper>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/projects.js